const About = () => {
  return (
    <div style={{ padding: "10px" }}>
      <ul>
        <li><strong style={{ width: "100px" }}>Name:</strong> M Amin Haris</li>
        <li><strong style={{ width: "100px" }}>Status:</strong> Frontend Developer</li>
        <li><strong style={{ width: "100px" }}>Email:</strong> amin.haris3323@gmail.com</li>
        <li><strong style={{ width: "100px" }}>Github Account:</strong> https://github.com/Haris-ism</li>
        <li><strong style={{ width: "100px" }}>Phone Number:</strong> +6285314816356</li>
      </ul>
    </div>
  )
}

export default About
